/* 🤖 this file was generated by svg-to-ts */
export const mgcIconFlag2CuteFi: {
  name: 'flag-2-cute-fi';
  data: string;
} = {
  name: 'flag-2-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M16.887 2.242c-.412.074-6.998 1.604-7.907 1.837-.506.13-1.136.31-1.4.401-2.133.734-3.147 1.928-3.439 4.048-.117.856-.14 2.027-.14 7.315-.001 5.959-.023 5.538.298 5.858a.984.984 0 0 0 1.402 0c.302-.302.299-.271.299-2.725 0-2.032.004-2.172.07-2.192.039-.012 1.672-.392 3.63-.844 3.939-.91 5.008-1.175 5.72-1.42 2.136-.734 3.162-1.947 3.44-4.066.086-.653.132-1.896.158-4.214.03-2.593-.009-3.024-.311-3.465-.139-.203-.45-.423-.706-.498-.201-.059-.863-.08-1.114-.035"/></svg>`
};
